/* eslint-disable consistent-return */
/* eslint-disable prefer-template */
/* eslint-disable no-else-return */
import moment from 'moment';
import _ from 'lodash';
import jwtDecode from 'jwt-decode';
import short from 'short-uuid';
import { format as dateFormat } from 'date-fns';

export const checkIsHasDelete = (multiUpdate) => {
	if (typeof multiUpdate === 'undefined') {
		return true;
	}
	if (multiUpdate.type === 'lots' || multiUpdate.type === 'contacts') {
		return !!multiUpdate.removeItem;
	}
	return true;
};

export const formatDateWithoutTz = (date) => dateFormat(date, 'yyyy-MM-dd HH:mm:ss');

export const dateFormatter = (date, formatType = 'DD MMM YYYY, HH:mm') =>
	moment(date).format(formatType);

export const dateReminderFormatter = (date) => {
	const dateHours = new Date(date).getHours();
	const dateMins = new Date(date).getMinutes();
	return moment(date).format(dateHours || dateMins ? 'HH:mm / DD MMM YYYY ' : 'DD MMM YYYY');
};

export const dateFormatterDays = (date, formatType = 'DD MMM YYYY') =>
	moment(date).format(formatType);

export const dateFormatterMonth = (date, formatType = 'MMM YYYY') =>
	date ? moment(date).format(formatType) : '-';

export const actualDate = () => moment(moment().toDate()).format('L');

export const priceFormatter = (price) => {
	if (price === 0) {
		return '$0';
	}
	if (!price) return;

	return (
		'$' +
		Number(price)
			.toString()
			.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	);
};

export const priceFormatterDecimal = (price) => {
	if (!price) return null;
	const val = typeof price === 'string' ? parseFloat(price.replace(/,/g, '')) : price;
	return val.toLocaleString('en-AU', { currency: 'AUD', style: 'currency' });
};

export const priceFormatterNull = (price) => {
	if (Number(price) === 0) {
		return 0;
	} else if (!price) {
		return null;
	}

	return '$' + price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

export const formatStageName = (stage) =>
	stage?.name ? `${stage?.number} (${stage?.name})` : `${stage?.number}`;

export const checkStatus = (status) => {
	if (status === 'Available' || status === 'Active') {
		return 'success';
	} else if (status === 'Deposited') {
		return 'warning';
	} else if (status === 'Sold') {
		return 'error';
	} else if (status === 'Unreleased' || status === 'Coming Soon') {
		return 'info';
	} else if (status === 'On Hold' || status === 'Put & Call') {
		return 'onHold';
	} else if (status === 'Settled') {
		return 'settled';
	}
};

export const checkTimeframe = (status) => {
	if (status === '0-3 months' || status === '3-6 months') {
		return 'success';
	} else if (status === '6-9 months' || status === '9-12 months' || status === '12+ months') {
		return 'warning';
	} else if (status === 'Unqualified' || status === 'Attempting to Contact') {
		return 'settled';
	} else if (status === 'Cold/No Response' || status === 'Information only') {
		return 'onHold';
	} else if (status === 'Next Release' || status === 'Opt Out') {
		return 'info';
	} else if (status === 'Purchased Elsewhere') {
		return 'black';
	} else if (status === 'Already Purchased') {
		return 'error';
	}
};

export const checkStep = (status) => {
	if (
		status === 'Contract Exchange' ||
		status === 'Deposit Payment' ||
		status === 'Conditional'
	) {
		return 'warning';
	} else if (status === 'Initial Deposit') {
		return 'settled';
	} else if (status === 'Unconditional') {
		return 'error';
	} else if (status === 'Settled') {
		return 'onHold';
	} else if (status === 'Cancelled') {
		return 'defaultGrey';
	} else if (status === 'Cancelled (Not Refunded)') {
		return 'black';
	} else if (status === 'Transferred') {
		return 'transferred';
	}
};

export const getColumnValue = (data, prop) => {
	if (!prop) return null;
	let result = data;
	const propArray = prop.split('.');

	propArray.forEach((p) => {
		if (result && result[p] instanceof Array) {
			result = getColumnValue(result[p][0], 'name');
		} else if (result) {
			result = result[p];
		} else {
			return result;
		}
	});

	return result;
};

export const isAdmin = () => {
	const user = jwtDecode(localStorage.getItem('token'));
	return user && user.permissions.indexOf('admin') > -1;
};

export const isSuperAdmin = () => {
	const user = jwtDecode(localStorage.getItem('token'));
	return user && user.permissions.indexOf('super_admin') > -1;
};

export const checkIsPositiveNumber = (event) => {
	const value = String.fromCharCode(event.which);

	if (!/[0-9,.]/.test(value)) {
		event.preventDefault();
	}
};

export const checkIsPositiveInteger = (event) => {
	const value = String.fromCharCode(event.which);

	if (!/[0-9]/.test(value)) {
		event.preventDefault();
	}
};

export const getPrimaryPhone = (phones) => {
	const primaryPhone = _.find(phones, { phonePrimary: true })?.phoneNumber;
	const displayPhone = primaryPhone?.length > 0 ? `${primaryPhone}` : ' - ';
	return displayPhone;
};

export const getDiff = (obj) => {
	const arr = [];
	if (!obj) {
		arr.push({ name: '' });
		return arr;
	}

	const FIELD_LABELS = {
		firstName: 'First name',
		lastName: 'Last name',
		middleName: 'Middle name',
		prefferedName: 'Preferred name',
		email: 'Email',
		emails: 'Emails',
		phones: 'Phones',
		addresses: 'Addresses',
		purchaseTimeframe: 'Purchase timeframe',
		contactGroups: 'Contact groups',
		communicationsEnabled: 'Correspondence',
		correspondence: 'Correspondence',
		smsCorrespondence: 'SMS correspondence',
		emailCorrespondence: 'Email correspondence',
		howDidYouHearAboutUs: 'Initial enquiry source',
		contactMethod: 'Contact method',
		leadSource: 'Lead source',
		buyerType: 'Buyer type',
		yearOfBirth: 'Birthday',
		trackingEnabled: 'Tracking',
		hotLead: 'Hot lead',
		favouriteLots: 'Favourite lots',
		favouritePackages: 'Favourite packages',
		linkedContact: 'Linked contact',
		survey: 'Survey',
		documents: 'Documents',
		deliveryIssues: 'Delivery issues',
		mergedFrom: 'Merged from',
		mergedInto: 'Merged into',
		source: 'Source',
		// Lot
		status: 'Status',
		previousStatus: 'Previous status',
		stage: 'Stage',
		stageId: 'Stage',
		previousStageId: 'Previous stage',
		humanId: 'Lot number',
		price: 'Price',
		sqm: 'SQM',
		streetAddress: 'Street address',
		orientation: 'Orientation',
		corner: 'Corner',
		irregular: 'Irregular',
		parkFront: 'Park front',
		disableStatus: 'Disable status',
		enabled: 'Enabled',
		titled: 'Titled',
		dimensions: 'Dimensions',
		constructed: 'Constructed',
		approvalStatus: 'Approval status',
		builderId: 'Builder',
		geo: 'Map geometry',
		mapGeometry: 'Map geometry',
		deletedAt: 'Deleted at',
		deletedById: 'Deleted by',
		// Sale / process / payment
		step: 'Sale stage',
		salePrice: 'Sale price',
		saleType: 'Sale type',
		variationReason: 'Variation reason',
		purchaserContacts: 'Purchasers',
		salesPerson: 'Salesperson',
		companyPurchaser: 'Company purchaser',
		rebate: 'Rebate',
		rebateNote: 'Rebate note',
		rebateAmount: 'Rebate amount',
		builderReferral: 'Builder referral',
		builderReferralAmount: 'Builder referral amount',
		builderReferralContacts: 'Builder referral contacts',
		customerReferral: 'Customer referral',
		customerReferralAmount: 'Customer referral amount',
		customerReferralContact: 'Customer referral contact',
		contractSigningDate: 'Contract signing date',
		purchaserSignedDate: 'Purchaser signed date',
		vendorSignedDate: 'Vendor signed date',
		exchangedDate: 'Exchanged date',
		contractExchangeTerms: 'Settlement terms',
		exchange: 'Exchange',
		extendButton: 'Extend',
		sunsetDate: 'Sunset date',
		sunsetDateMonths: 'Sunset date (months)',
		unconditionalDate: 'Unconditional date',
		terms: 'Terms',
		unconditionalDropdown: 'Unconditional from',
		fixedSettlementDate: 'Fixed settlement date',
		anticipatedSettlementDate: 'Anticipated settlement date',
		settlementBookedDate: 'Settlement booked date',
		unconditionalCheckbox: 'Unconditional',
		conditionalCheckbox: 'Conditional',
		rebateConditionsMet: 'Rebate conditions met',
		saleOptions: 'Sale options',
		customSaleOptions: 'Custom sale options',
		saleOptionsPrice: 'Sale options price',
		paymentAmount: 'Payment amount',
		paymentDate: 'Payment date',
		paymentForm: 'Payment form',
		paymentType: 'Payment type',
		receiptNo: 'Receipt number',
		initialDeposit: 'Initial deposit',
		fullDeposit: 'Full deposit / due date',
		settlementDeposit: 'Settlement deposit',
		refundDeposit: 'Refund deposit',
		depositPayment: 'Deposit payment',
		depositBalance: 'Deposit balance',
		depositPaymentRemoved: 'Deposit payment removed',
		depositRemoved: 'Deposit payment removed',
		dateStarted: 'Date started',
		package: 'Package',
		initialDepositAmount: 'Initial deposit amount',
		fullDepositAmount: 'Full deposit amount',
		settlementDepositAmount: 'Settlement deposit amount',
		conditions: 'Conditions',
		finalized: 'Settled',
		settled: 'Settled',
		refunded: 'Refunded',
		cancelled: 'Cancelled',
		cancelReason: 'Cancel reason',
		cancelDate: 'Cancel date',
		costsRefunded: 'Costs refunded',
		transferred: 'Transferred',
		transferReason: 'Transfer reason',
		transferDate: 'Transfer date',
		lot: 'Lot',
		lotId: 'Lot',
		// Package
		fixedPrice: 'Fixed price',
		houseType: 'House type',
		houseTypeId: 'House type',
		optionsList: 'Options list',
		optionsListId: 'Options list',
		dwellingContract: 'Dwelling contract',
		packageFacade: 'Facade',
		documentAdded: 'Document added',
		documentType: 'Document type'
	};

	const NOISE_KEYS = new Set([
		'id',
		'createdAt',
		'updatedAt',
		'saleId',
		'projectId',
		'userId',
		'lotId',
		'project',
		'user',
		'purchaser',
		'mongoReferenceId',
		'source',
		'previousStep',
		'previousStatus',
		'previousStageId',
		'deletedAt',
		'deletedById',
		'mongoReferenceId',
		'disableStatus',
		'type',
		'paymentDeleted',
		'optionsListVersion',
		'saleId'
	]);

	const UUID_RE =
		/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
	const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}T[\d:.]+Z?$/;
	const LOT_BOOL_KEYS = new Set([
		'corner',
		'irregular',
		'parkFront',
		'titled',
		'constructed',
		'disableStatus',
		'enabled',
		'fixedPrice',
		'dwellingContract'
	]);
	const LOT_MONEY_KEYS = new Set(['price', 'salePrice', 'saleOptionsPrice']);

	const looksLikeGeoJson = (text) => {
		const s = String(text || '').trim();
		return (
			s.includes('"coordinates"') ||
			s.includes("'coordinates'") ||
			(s.includes('"type"') && (s.includes('Feature') || s.includes('Polygon')))
		);
	};

	const parseLooseJson = (text) => {
		const s = String(text || '').trim();
		if (!s) return null;
		try {
			return JSON.parse(s);
		} catch (_) {
			try {
				return JSON.parse(s.replace(/'/g, '"'));
			} catch (__) {
				return null;
			}
		}
	};

	const formatLotDimensionsDisplay = (raw) => {
		let dims = raw;
		if (typeof raw === 'string') {
			dims = parseLooseJson(raw);
			if (!dims) return String(raw);
		}
		if (!dims || typeof dims !== 'object') return String(raw ?? '');
		const width = dims.width ?? dims.W ?? dims.w;
		const depth = dims.depth ?? dims.D ?? dims.d;
		const parts = [];
		if (width != null && width !== '') parts.push(`W ${width}`);
		if (depth != null && depth !== '') parts.push(`D ${depth}`);
		return parts.length ? parts.join(' × ') : String(raw);
	};

	const formatLotMoneyDisplay = (raw) => {
		const num = Number(String(raw).replace(/,/g, ''));
		if (Number.isNaN(num)) return String(raw);
		return new Intl.NumberFormat('en-AU', {
			style: 'currency',
			currency: 'AUD',
			minimumFractionDigits: Number.isInteger(num) ? 0 : 2,
			maximumFractionDigits: 2
		}).format(num);
	};

	const formatLotHistoryPart = (key, part) => {
		const trimmed = String(part ?? '').trim();
		if (!trimmed || trimmed === '(empty)') return trimmed || '(empty)';

		if (looksLikeGeoJson(trimmed)) {
			return 'Updated';
		}
		if (key === 'dimensions') {
			return formatLotDimensionsDisplay(trimmed);
		}
		if (LOT_MONEY_KEYS.has(key) && /^-?\d+(\.\d+)?$/.test(trimmed)) {
			return formatLotMoneyDisplay(trimmed);
		}
		if (LOT_BOOL_KEYS.has(key)) {
			if (trimmed === 'true' || trimmed === 'Yes') return 'Yes';
			if (trimmed === 'false' || trimmed === 'No') return 'No';
		}
		if (
			(key === 'stage' ||
				key === 'stageId' ||
				key === 'builderId' ||
				key === 'houseType' ||
				key === 'houseTypeId' ||
				key === 'optionsList' ||
				key === 'optionsListId' ||
				key === 'lot' ||
				key === 'lotId') &&
			UUID_RE.test(trimmed)
		) {
			return ''; // hide bare UUID
		}
		if (ISO_DATE_RE.test(trimmed)) {
			return formatAuDate(trimmed);
		}
		return trimmed;
	};

	const SALE_STEP_LABELS = {
		'-1': 'Cancelled (Not Refunded)',
		0: 'Cancelled',
		1: 'Initial Deposit',
		2: 'Contract Exchange',
		3: 'Deposit Payment',
		4: 'Conditional',
		5: 'Unconditional',
		7: 'Settled',
		8: 'Transferred'
	};

	const formatAuDate = (value) => {
		const date = new Date(value);
		if (Number.isNaN(date.getTime())) {
			return String(value);
		}
		return new Intl.DateTimeFormat('en-AU', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			timeZone: 'Australia/Sydney'
		}).format(date);
	};

	const formatStepPart = (part) => {
		const trimmed = String(part).trim();
		const num = Number(trimmed);
		if (!Number.isNaN(num) && SALE_STEP_LABELS[num] !== undefined) {
			return SALE_STEP_LABELS[num];
		}
		return trimmed;
	};

	const formatValue = (value) => {
		if (value === null || value === undefined) {
			return '';
		}
		if (typeof value === 'boolean') {
			return String(value);
		}
		if (typeof value === 'object') {
			return JSON.stringify(value);
		}
		return String(value);
	};

	const formatLegacyDisplayValue = (key, value) => {
		let formatted = formatValue(value);

		if (key === 'step') {
			if (formatted.includes(' → ')) {
				return formatted
					.split(' → ')
					.map((part) => formatStepPart(part))
					.join(' → ');
			}
			return formatStepPart(formatted);
		}

		if (ISO_DATE_RE.test(formatted.trim())) {
			return formatAuDate(formatted);
		}

		if (formatted.includes(' → ')) {
			return formatted
				.split(' → ')
				.map((part) => {
					const trimmed = part.trim();
					if (ISO_DATE_RE.test(trimmed)) {
						return formatAuDate(trimmed);
					}
					return trimmed;
				})
				.join(' → ');
		}

		return formatted;
	};

	Object.entries(obj).forEach(([key, value]) => {
		if (NOISE_KEYS.has(key)) {
			return;
		}

		let formatted = formatLegacyDisplayValue(key, value);

		// Skip blank legacy dumps: "builderId changed to:", "orientation changed to:"
		if (!formatted || !String(formatted).trim()) {
			return;
		}

		// Lot nested / typed display (geo JSON, dimensions quotes, price, bool, stage UUID)
		const lotKeys = new Set([
			'geo',
			'mapGeometry',
			'dimensions',
			'price',
			'sqm',
			'corner',
			'irregular',
			'parkFront',
			'titled',
			'constructed',
			'stage',
			'stageId',
			'builderId',
			'humanId',
			'status',
			'streetAddress',
			'orientation',
			'enabled',
			'fixedPrice',
			'dwellingContract',
			'houseType',
			'houseTypeId',
			'optionsList',
			'optionsListId',
			'lot',
			'lotId'
		]);
		if (lotKeys.has(key) || looksLikeGeoJson(formatted)) {
			if (formatted.includes(' → ')) {
				formatted = formatted
					.split(' → ')
					.map((part) => formatLotHistoryPart(key === 'geo' ? 'geo' : key, part) || '(empty)')
					.join(' → ');
				// Drop UUID → UUID stage lines
				if (
					formatted
						.split(' → ')
						.every((p) => !p.trim() || p.trim() === '(empty)')
				) {
					return;
				}
			} else {
				formatted = formatLotHistoryPart(key === 'geo' || looksLikeGeoJson(formatted) ? 'geo' : key, formatted);
			}
		}

		if (!formatted || !String(formatted).trim()) {
			return;
		}

		// Legacy payment leaks stored lot as a bare UUID — hide those only
		if (key === 'lot' && !formatted.includes(' → ') && UUID_RE.test(formatted.trim())) {
			return;
		}

		const label =
			key === 'geo' ? FIELD_LABELS.mapGeometry || 'Map geometry' : FIELD_LABELS[key] || key;

		if (formatted.includes(' → ')) {
			arr.push({ name: `${label}: ${formatted}` });
		} else if (key === 'mergedFrom' || key === 'mergedInto') {
			arr.push({ name: `${label}: ${formatted}` });
		} else {
			arr.push({ name: `${label} changed to: ${formatted}` });
		}
	});

	return arr;
};

export const slugify = (string, id) => {
	if (!string) return '';
	const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
	const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
	const p = new RegExp(a.split('').join('|'), 'g');
	return (
		string
			.toString()
			.toLowerCase()
			.replace(/\s+/g, '-') // Replace spaces with -
			.replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
			.replace(/&/g, '-and-') // Replace & with 'and'
			.replace(/[^\w-]+/g, '') // Remove all non-word characters
			.replace(/--+/g, '-') // Replace multiple - with single -
			.replace(/^-+/, '') // Trim - from start of text
			.replace(/-+$/, '') + // Trim - from end of text
		(id
			? '_' +
			  short(short.constants.flickrBase58, {
					consistentLength: false
			  }).fromUUID(id)
			: '')
	);
};

function fallbackCopyTextToClipboard(text) {
	const textArea = document.createElement('textarea');
	textArea.value = text;

	// Avoid scrolling to bottom
	textArea.style.top = '0';
	textArea.style.left = '0';
	textArea.style.position = 'fixed';

	document.body.appendChild(textArea);
	textArea.focus();
	textArea.select();
	document.execCommand('copy');
	document.body.removeChild(textArea);
}
export function copyTextToClipboard(text) {
	if (!navigator.clipboard) {
		fallbackCopyTextToClipboard(text);
		return;
	}
	navigator.clipboard.writeText(text);
}

export function videoToImageURL(url = '') {
	return url.replace(
		/\.(3gp|3g2|asf|wmv|avi|divx|evo|f4v|flv|mkv|mk3d|mp4|mpg|mpeg|m2p|ps|ts|m2ts|mxf|ogg|ogv|ogx|mov|qt|rmvb|vob|webm)$/gi,
		'.png'
	);
}

export const projectsDomains = [
	'@intrapac.com.au',
	'@aureus.com.au',
	'@banyanhill.com.au',
	'@ellarook.com.au',
	'@harvestrise.com.au',
	'@kingscoast.com.au',
	'@kinley.com.au',
	'@mirawood.com.au',
	'@quay2.com.au',
	'@somerfield.com.au',
	'@mywhiterock.com.au'
];
export function checkIsImageFormat(format) {
	if (format?.match(/.(jpg|jpeg|png|gif)$/i)) {
		return true;
	}
	return false;
}

const getSortData = (sort, type) => {
	const direction = sort.sortDirection === 'ascending' ? -1 : 1;
	let { sortBy } = sort;

	if (type === 'lots') {
		if (sort.sortBy === 'dimensionsW') {
			sortBy = 'dimensions.width';
		}
		if (sort.sortBy === 'dimensionsD') {
			sortBy = 'dimensions.depth';
		}
		if (sort.sortBy === 'stageLot') {
			sortBy = 'stage.number';
		}
		if (sort.sortBy === 'titled') {
			sortBy = 'stage.titlesAvailable';
		}
	}
	if (type === 'contacts') {
		if (sort.sortBy === 'number') {
			sortBy = 'primaryPhone';
		}
		if (sort.sortBy === 'contactGroup') {
			sortBy = 'contactGroupLength';
		}
	}
	if (type === 'reminder') {
		if (sort.sortBy === 'reminderDate') {
			sortBy = 'dueDate';
		}
		if (sort.sortBy === 'userName') {
			sortBy = 'userId.name';
		}
	}
	if (type === 'sales') {
		if (sort.sortBy === 'salePrice') {
			sortBy = 'salePriceTotal';
		}
		if (sort.sortBy === 'onlyDate') {
			sortBy = 'process.initialDeposit.paymentDate';
		}
		if (sort.sortBy === 'lot') {
			sortBy = 'lotNumber.humanId';
		}
		if (sort.sortBy === 'seller') {
			sortBy = 'salesPerson.name';
		}
		if (sort.sortBy === 'contact') {
			sortBy = 'purchaserContactLength';
		}
		if (sort.sortBy === 'stepValues') {
			sortBy = 'step';
		}
	}
	if (type === 'contactNotes') {
		if (sort.sortBy === 'userName') {
			sortBy = 'user.name';
		}
		if (sort.sortBy === 'contactName') {
			sortBy = 'contact.name';
		}
		if (sort.sortBy === 'serializedMemo') {
			sortBy = 'memoDesc';
		}
	}

	return { direction, sortBy };
};

export const getBodyPaginate = (data, type) => {
	const { page, perPage, defaultLimit, filtersData = {}, packageCheck, myMessages } = data;

	const {
		filters: { surveyId, selectedOptions, questionFilters, repeatEnquiries, ...filters } = {},
		search,
		sort,
		settled,
		hotLeads,
		inactiveContacts,
		showSensoreal,
		id,
		contactsIds,
		completedReminders,
		allReminders,
		reminderDateRange,
		communicationsEnabled,
		dwellingLots,
		saleSettled,
		saleCancellation,
		contactGroup
	} = filtersData;

	let reqBody = {};
	if (id) {
		reqBody.id = id;
	}
	if (contactsIds?.length) {
		reqBody.contactsId = contactsIds;
	}
	if (contactGroup) {
		reqBody.contactGroup = contactGroup;
	}
	if (completedReminders) {
		reqBody.completedReminders = completedReminders;
	}
	if (allReminders) {
		reqBody.allReminders = allReminders;
	}
	if (reminderDateRange) {
		reqBody.reminderDateRange = reminderDateRange;
	}
	if (page && perPage) {
		reqBody.page = page;
		reqBody.perPage = perPage;
		reqBody.defaultLimit = defaultLimit || 25;
	}
	if (settled !== undefined) {
		reqBody.settled = settled;
	}
	if (dwellingLots !== undefined) {
		reqBody.dwellingLots = dwellingLots;
	}
	if (hotLeads !== undefined) {
		reqBody.hotLeads = hotLeads;
	}
	if (inactiveContacts !== undefined) {
		reqBody.inactiveContacts = inactiveContacts;
	}
	if (showSensoreal !== undefined && showSensoreal === true) {
		reqBody.leadSource = 'sensoreal';
	}
	if (communicationsEnabled) {
		reqBody.communicationsEnabled = communicationsEnabled;
	}
	if (myMessages) {
		reqBody.myMessages = myMessages;
	}
	if (saleSettled) {
		reqBody.saleSettled = saleSettled;
	}
	if (saleCancellation) {
		reqBody.saleCancellation = saleCancellation;
	}
	if (surveyId) {
		reqBody.surveyId = surveyId;
	}
	if (questionFilters?.length) {
		reqBody.questionFilters = JSON.stringify(questionFilters);
	} else if (selectedOptions) {
		reqBody.selectedOptions = selectedOptions;
	}
	if (repeatEnquiries) {
		reqBody.repeatEnquiries = repeatEnquiries;
	}
	if (Array.isArray(filters?.saleIds)) {
		reqBody.saleIds = filters.saleIds;
	}
	if (typeof filters?.cancelStep === 'string' && filters.cancelStep) {
		reqBody.cancelStep = filters.cancelStep;
	}
	if (filters && Object.keys(filters).length) {
		Object.keys(filters).forEach((value) => {
			if (value === 'saleIds' || value === 'cancelStep') return;
			if (filters[value].length) {
				reqBody = {
					...reqBody,
					[value]: []
				};
				filters[value].map((itm) => reqBody[value].push(itm));
			}
		});
	}
	if (sort?.sortDirection && sort?.sortBy) {
		const { direction, sortBy } = getSortData(sort, type);
		reqBody.sortDirection = direction;
		reqBody.sortBy = sortBy;
	}
	if (search) {
		reqBody.search = search;
	}
	if (filters?.read) {
		if (filters?.read?.length === 1) {
			// both selected or no one selected
			if (filters?.read?.includes(true)) {
				reqBody.read = true;
			} else {
				reqBody.read = false;
			}
		} else {
			delete reqBody.read;
		}
	}
	if (filters?.settlementDate === true) {
		reqBody.settlementDate = [null, new Date()];
	}
	if (packageCheck || packageCheck === false) {
		reqBody.package = packageCheck;
	}

	return reqBody;
};

export const sliceIntoChunks = (arr, chunkSize) => {
	const res = [];
	for (let i = 0; i < arr.length; i += chunkSize) {
		const chunk = arr.slice(i, i + chunkSize);
		res.push(chunk);
	}
	return res;
};

export const calculateSaleUnconditionalDate = (saleData) => {
	const exchangedDatePurchaser = saleData?.purchaserSignedDate;
	const exchangedDateVendor = saleData?.vendorSignedDate;
	const lastDepositPayment = saleData.deposit[saleData.deposit.length - 1]?.paymentDate;
	const latestConditionMet =
		saleData.conditionalCheckbox &&
		saleData.conditions.find((el) => el.conditionsMet)?.conditionDate;

	const dates = [];

	if (exchangedDatePurchaser) dates.push(moment(exchangedDatePurchaser));
	if (exchangedDateVendor) dates.push(moment(exchangedDateVendor));
	if (lastDepositPayment) dates.push(moment(lastDepositPayment));
	if (latestConditionMet) dates.push(moment(latestConditionMet));

	const unconditionalDate = moment.max(dates);

	return unconditionalDate;
};

export const isBlackColor = (color) => {
	let c = color;
	c = c.substring(1);
	const rgb = parseInt(c, 16);
	const r = (rgb >> 16) & 0xff; // eslint-disable-line no-bitwise
	const g = (rgb >> 8) & 0xff; // eslint-disable-line no-bitwise
	const b = (rgb >> 0) & 0xff; // eslint-disable-line no-bitwise

	const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
	if (luma < 61) {
		return true;
	}

	return false;
};

export const getAustralianFinancialYearRange = (now = moment()) => {
	const fyStartYear = now.month() >= 6 ? now.year() : now.year() - 1;
	return {
		fyStart: moment({ year: fyStartYear, month: 6, date: 1 }).startOf('day'),
		fyEnd: moment({ year: fyStartYear + 1, month: 5, date: 30 }).endOf('day')
	};
};

export const getAustralianFinancialYearMonthBounds = (monthName, now = moment()) => {
	const { fyStart, fyEnd } = getAustralianFinancialYearRange(now);
	const monthIndex = moment(monthName, 'MMM').month();
	const year = monthIndex >= 6 ? fyStart.year() : fyEnd.year();
	const startDate = moment({ year, month: monthIndex, date: 1 }).startOf('month');
	return {
		startDate: startDate.format(),
		endDate: startDate.clone().endOf('month').format()
	};
};

export const exchangedDate = (one, two) => {
	// eslint-disable-next-line no-underscore-dangle
	const date = moment.max([moment(one), moment(two)])._i;

	return date;
};
